//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getDetail(key){
    return _axios({
        url: `/api/outOfStore/getDetail?id=${key}`,
        method: 'get'
    })
}

export function submit(data){
    return _axios({
        url: `/api/outOfStore/submit`,
        method: 'post',
        data:data
    })
}
